// analytics/ProductAnalytics.ts
import { getToken } from '@/services/_utils';
import { AnalyticsProvider } from './AnalyticTypes';
import { createAnalyticsProvider } from './AnalyticsFactory';

interface ProductAnalyticsDefaultProperties {
  schemaName?: string;
  subsidiaryId?: string;
  email?: string;
}

class ProductAnalytics {
  private provider: AnalyticsProvider | undefined;

  constructor() {
    this.provider = createAnalyticsProvider();
  }

  trackEvent(eventName: string, properties?: Record<string, any>) {
    let defaultProperties: ProductAnalyticsDefaultProperties | null = null;
    try {
      const token = getToken();
      const email = token?.email;
      const schemaName = token?.['custom:schema_name'];
      const subsidiaryId = token?.['custom:subsidiary_id'];
      defaultProperties = {
        schemaName,
        subsidiaryId,
        email,
      };
    } catch (error) {
      console.error('Error tracking event:', error);
    }
    if (!defaultProperties) {
      defaultProperties = {};
    }
    const eventProperties = { ...defaultProperties, ...properties };
    if (!this.provider) {
      console.info('[ANALYTICS] Analytics provider is not initialized.');
      return;
    }
    this.provider.trackEvent(eventName, eventProperties);
  }
}

export const productAnalytics = new ProductAnalytics();
